/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedOrderListListResponse } from '../types/PaginatedOrderListList';
import type { Formats } from '../types/Formats';
import type { Origin } from '../types/Origin';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type OrdersListRequest = {} | null | undefined;
export type OrdersListResponse = PaginatedOrderListListResponse;

export type OrdersListQuery = {
  /**
   * ```yaml
   * in: query
   * name: created__gte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: created__lt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__lt?: string;

  /**
   * ```yaml
   * in: query
   * name: dmvs_id_podani
   * schema:
   *   type: string
   * ```
   */
  dmvs_id_podani?: string;

  /**
   * ```yaml
   * in: query
   * name: dmvs_id_podani__icontains
   * schema:
   *   type: string
   * ```
   */
  dmvs_id_podani__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: dmvs_source
   * schema:
   *   type: string
   *   nullable: true
   *   enum:
   *     - R20B_STAVOVA
   *     - R20B_ZMENOVA
   *     - R21B_STAVOVA
   *     - R21B_ZMENOVA
   *     - R22B_VSP
   *     - R27A_NEVEREJNA
   *     - R27A_VEREJNA
   *     - R30B_SYNCHRONIZACNI
   * description: |-
   *   * `R20B_STAVOVA` - R20b neverejna stavova
   *   * `R20B_ZMENOVA` - R20b neverejna zmenova
   *   * `R21B_STAVOVA` - r21b verejna stavova
   *   * `R21B_ZMENOVA` - r21b verejna zmenova
   *   * `R22B_VSP` - r22b vsp
   *   * `R27A_VEREJNA` - r27a verejna
   *   * `R27A_NEVEREJNA` - r27a neverejna
   *   * `R30B_SYNCHRONIZACNI` - r30b synchronizacni
   * ```
   */
  dmvs_source?:
    | (
        | 'R20B_STAVOVA'
        | 'R20B_ZMENOVA'
        | 'R21B_STAVOVA'
        | 'R21B_ZMENOVA'
        | 'R22B_VSP'
        | 'R27A_NEVEREJNA'
        | 'R27A_VEREJNA'
        | 'R30B_SYNCHRONIZACNI'
      )
    | null;

  /**
   * ```yaml
   * in: query
   * name: dmvs_source__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     nullable: true
   *     enum:
   *       - R20B_STAVOVA
   *       - R20B_ZMENOVA
   *       - R21B_STAVOVA
   *       - R21B_ZMENOVA
   *       - R22B_VSP
   *       - R27A_NEVEREJNA
   *       - R27A_VEREJNA
   *       - R30B_SYNCHRONIZACNI
   * description: |-
   *   dmvs_source in
   *
   *   * `R20B_STAVOVA` - R20b neverejna stavova
   *   * `R20B_ZMENOVA` - R20b neverejna zmenova
   *   * `R21B_STAVOVA` - r21b verejna stavova
   *   * `R21B_ZMENOVA` - r21b verejna zmenova
   *   * `R22B_VSP` - r22b vsp
   *   * `R27A_VEREJNA` - r27a verejna
   *   * `R27A_NEVEREJNA` - r27a neverejna
   *   * `R30B_SYNCHRONIZACNI` - r30b synchronizacni
   * explode: true
   * style: form
   * ```
   */
  dmvs_source__in?: (
    | 'R20B_STAVOVA'
    | 'R20B_ZMENOVA'
    | 'R21B_STAVOVA'
    | 'R21B_ZMENOVA'
    | 'R22B_VSP'
    | 'R27A_NEVEREJNA'
    | 'R27A_VEREJNA'
    | 'R30B_SYNCHRONIZACNI'
  )[];

  /**
   * ```yaml
   * in: query
   * name: dmvs_source__isnull
   * schema:
   *   type: boolean
   * ```
   */
  dmvs_source__isnull?: boolean;

  /**
   * ```yaml
   * in: query
   * name: formats__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - DGN
   *       - DWG
   *       - DXF
   *       - FGDB
   *       - GPKG
   *       - JPG
   *       - JVF
   *       - PNG
   *       - SHP
   *       - TIF
   *       - VTX
   * description: |-
   *   Publishset required formats
   *
   *   * `DGN` - DGN
   *   * `DWG` - DWG
   *   * `DXF` - DXF
   *   * `FGDB` - FGDB
   *   * `GPKG` - GPKG
   *   * `JPG` - JPG
   *   * `JVF` - JVF
   *   * `PNG` - PNG
   *   * `SHP` - SHP
   *   * `TIF` - TIF
   *   * `VTX` - VTX
   * explode: true
   * style: form
   * ```
   */
  formats__in?: Formats[];

  /**
   * ```yaml
   * in: query
   * name: from_primary_db
   * schema:
   *   type: boolean
   * ```
   */
  from_primary_db?: boolean;

  /**
   * ```yaml
   * in: query
   * name: handling_fee
   * schema:
   *   type: boolean
   * ```
   */
  handling_fee?: boolean;

  /**
   * ```yaml
   * in: query
   * name: id
   * schema:
   *   type: integer
   * ```
   */
  id?: number;

  /**
   * ```yaml
   * in: query
   * name: is_public
   * schema:
   *   type: boolean
   * ```
   */
  is_public?: boolean;

  /**
   * ```yaml
   * in: query
   * name: origin
   * schema:
   *   type: string
   *   nullable: true
   *   enum:
   *     - COUNTER
   *     - EVYDEJ
   * description: |-
   *   * `EVYDEJ` - eVýdej
   *   * `COUNTER` - Přepážka
   * ```
   */
  origin?: ('COUNTER' | 'EVYDEJ') | null;

  /**
   * ```yaml
   * in: query
   * name: origin__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     nullable: true
   *     enum:
   *       - COUNTER
   *       - EVYDEJ
   * description: |-
   *   origin in
   *
   *   * `EVYDEJ` - eVýdej
   *   * `COUNTER` - Přepážka
   * explode: true
   * style: form
   * ```
   */
  origin__in?: Origin[];

  /**
   * ```yaml
   * in: query
   * name: originator__icontains
   * schema:
   *   type: string
   * description: Originator filter
   * ```
   */
  originator__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: published__gte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  published__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: published__lt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  published__lt?: string;

  /**
   * ```yaml
   * in: query
   * name: publishset_name__icontains
   * schema:
   *   type: string
   * description: Publishset name filter
   * ```
   */
  publishset_name__icontains?: string;

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;

  /**
   * ```yaml
   * in: query
   * name: selection_type
   * schema:
   *   type: string
   *   enum:
   *     - CUSTOM
   *     - PACKAGE
   * description: |-
   *   * `CUSTOM` - Custom
   *   * `PACKAGE` - Package
   * ```
   */
  selection_type?: 'CUSTOM' | 'PACKAGE';

  /**
   * ```yaml
   * in: query
   * name: state
   * schema:
   *   type: string
   *   enum:
   *     - APPROVED
   *     - DMVS_COMMUNICATION_FAILED
   *     - EXPIRED
   *     - FAILED
   *     - INTERRUPTED
   *     - PROCESSING
   *     - PUBLISHED
   *     - REJECTED
   *     - WAITING_FOR_APPROVAL
   *     - WAITING_FOR_INTERRUPTION
   *     - WAITING_FOR_PROCESSING
   * description: |-
   *   * `WAITING_FOR_APPROVAL` - Waiting for approval
   *   * `WAITING_FOR_PROCESSING` - Waiting for processing
   *   * `PROCESSING` - Processing
   *   * `WAITING_FOR_INTERRUPTION` - Waiting for interruption
   *   * `INTERRUPTED` - Interrupt
   *   * `REJECTED` - Rejected
   *   * `PUBLISHED` - Published
   *   * `FAILED` - Failed
   *   * `DMVS_COMMUNICATION_FAILED` - DMVS communication failed
   *   * `EXPIRED` - Expired
   *   * `APPROVED` - Approved
   * ```
   */
  state?:
    | 'APPROVED'
    | 'DMVS_COMMUNICATION_FAILED'
    | 'EXPIRED'
    | 'FAILED'
    | 'INTERRUPTED'
    | 'PROCESSING'
    | 'PUBLISHED'
    | 'REJECTED'
    | 'WAITING_FOR_APPROVAL'
    | 'WAITING_FOR_INTERRUPTION'
    | 'WAITING_FOR_PROCESSING';

  /**
   * ```yaml
   * in: query
   * name: state__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - APPROVED
   *       - DMVS_COMMUNICATION_FAILED
   *       - EXPIRED
   *       - FAILED
   *       - INTERRUPTED
   *       - PROCESSING
   *       - PUBLISHED
   *       - REJECTED
   *       - WAITING_FOR_APPROVAL
   *       - WAITING_FOR_INTERRUPTION
   *       - WAITING_FOR_PROCESSING
   * description: |-
   *   * `WAITING_FOR_APPROVAL` - Waiting for approval
   *   * `WAITING_FOR_PROCESSING` - Waiting for processing
   *   * `PROCESSING` - Processing
   *   * `WAITING_FOR_INTERRUPTION` - Waiting for interruption
   *   * `INTERRUPTED` - Interrupt
   *   * `REJECTED` - Rejected
   *   * `PUBLISHED` - Published
   *   * `FAILED` - Failed
   *   * `DMVS_COMMUNICATION_FAILED` - DMVS communication failed
   *   * `EXPIRED` - Expired
   *   * `APPROVED` - Approved
   * explode: true
   * style: form
   * ```
   */
  state__in?: (
    | 'APPROVED'
    | 'DMVS_COMMUNICATION_FAILED'
    | 'EXPIRED'
    | 'FAILED'
    | 'INTERRUPTED'
    | 'PROCESSING'
    | 'PUBLISHED'
    | 'REJECTED'
    | 'WAITING_FOR_APPROVAL'
    | 'WAITING_FOR_INTERRUPTION'
    | 'WAITING_FOR_PROCESSING'
  )[];

  /**
   * ```yaml
   * in: query
   * name: status_zadatele
   * schema:
   *   type: string
   *   nullable: true
   *   enum:
   *     - AZI
   *     - OPRAVNENY_ZADATEL
   *     - ORGAN_VEREJNE_MOCI
   *     - VLASTNIK_DOTCENYCH_NEMOVITOSTI
   *     - VLASTNIK_SPRAVCE_PROVOZOVATEL
   *     - ZADATEL_DLE_ZADOSTI
   *     - 'null'
   * description: |-
   *   Status zadatele filter
   *
   *   * `null` - Nezadáno
   *   * `OPRAVNENY_ZADATEL` - Oprávněný žadatel
   *   * `VLASTNIK_SPRAVCE_PROVOZOVATEL` - Vlastník Správce Provozovatel
   *   * `AZI` - Azi
   *   * `ZADATEL_DLE_ZADOSTI` - Žadatel dle žádosti
   *   * `ORGAN_VEREJNE_MOCI` - Orgán veřejné moci
   *   * `VLASTNIK_DOTCENYCH_NEMOVITOSTI` - Vlastník dotčených nemovitostí
   * ```
   */
  status_zadatele?:
    | (
        | 'AZI'
        | 'OPRAVNENY_ZADATEL'
        | 'ORGAN_VEREJNE_MOCI'
        | 'VLASTNIK_DOTCENYCH_NEMOVITOSTI'
        | 'VLASTNIK_SPRAVCE_PROVOZOVATEL'
        | 'ZADATEL_DLE_ZADOSTI'
        | 'null'
      )
    | null;
};

/**
 * GET /dmx-server/orders/
 *
 * ```yaml
 * operationId: orders_list
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedOrderListList'
 *     description: ''
 * ```
 */
export const ordersListOperation = (rest?: OrdersListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/orders/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/orders/' };
  };

/**
 * GET /dmx-server/orders/
 *
 * ```yaml
 * operationId: orders_list
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedOrderListList'
 *     description: ''
 * ```
 */
export const ordersList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrdersListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedOrderListListResponse>> => {
  const operation = ordersListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/orders/
 */
export const useOrdersListResource = (
  query: OrdersListQuery | null,
  useCached?: boolean,
): UseResource<OrdersListResponse> => {
  return useResource<OrdersListResponse>({
    path: query === null ? null : ordersListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
